import type { SVGProps } from "react";

export default function SolarWidget4Linear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M2.5 6.5c0-1.886 0-2.829.586-3.414S4.614 2.5 6.5 2.5s2.829 0 3.414.586S10.5 4.614 10.5 6.5v11c0 1.886 0 2.829-.586 3.414S8.386 21.5 6.5 21.5s-2.829 0-3.414-.586S2.5 19.386 2.5 17.5z" />
        <path d="M13.5 15.5c0-1.886 0-2.828.586-3.414s1.528-.586 3.414-.586s2.828 0 3.414.586s.586 1.528.586 3.414v2c0 1.886 0 2.828-.586 3.414s-1.528.586-3.414.586s-2.828 0-3.414-.586s-.586-1.528-.586-3.414z" />
        <path d="M13.5 5.5c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C15.102 2.5 15.568 2.5 16.5 2.5h2c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083c.152.367.152.833.152 1.765s0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C19.898 8.5 19.432 8.5 18.5 8.5h-2c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C13.5 6.898 13.5 6.432 13.5 5.5Z" />
      </g>
    </svg>
  );
}
